module.exports = window.dnn.nodeModules.ReduxImmutableStateInvariant;